import React, { useState, useEffect } from 'react'
import { AccountAlert, CloseIcon } from '../../Assets'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonCmp, DropDownCmp, InputCmp, WhiteButtonCmp } from '..'
import { useForm } from 'react-hook-form'
import styles from './ProfileForms.module.css'
import { Box, Typography, Grid } from '@mui/material'
import {
    CreateServiceAction,
    GetLicensedServicesAction,
    GetOtherServicesAction,
} from '../../Store/Actions/GetActions'
import { UpdateProfileAction } from '../../Store/Actions/ProfileAction'
import useAlert from '../../Hooks/useAlert/useAlert'

const ServicesForm = ({ handleCancel, profileDetailsdata }) => {
    const { services_licensed, services_other } = profileDetailsdata
    const [showOtherServiceInput, setShowOtherServiceInput] = useState(false)

    const [servicesArr, setServicesArr] = useState(
        services_licensed?.map((i, index) => i.service) || []
    )
    const [otherServicesArr, setOtherServicesArr] = useState(
        services_other?.map((i, index) => i.service) || []
    )
    const [constructionType, setConstructionType] = useState(
        profileDetailsdata.construction_type || ''
    )

    const { setAlert } = useAlert()
    const dispatch = useDispatch()
    // const { servicesdata } = useSelector((state) => state.ServicesReducer);
    const { licensedServicesdata } = useSelector(
        (state) => state.LicensedServicesReducer
    )
    const { otherServicesdata } = useSelector(
        (state) => state.OtherServicesReducer
    )
    const { createServiceLoading } = useSelector(
        (state) => state.CreateServiceReducer
    )

    const { control, handleSubmit, watch, setValue, getValues } = useForm({
        mode: 'onChange',
        defaultValues: {
            licensedService: '',
            otherService: '',
        },
    })

    const handleCancelOtherService = () => {
        setValue('newOtherService', '')
        setShowOtherServiceInput(false)
    }

    const handleAddNewOtherService = async () => {
        const newServiceValue = getValues('newOtherService')
        if (newServiceValue && newServiceValue.trim()) {
            const serviceData = {
                title: newServiceValue.trim(),
                isLicensed: false,
                // description: newServiceValue.trim()
            }

            const createdService = await dispatch(
                CreateServiceAction(serviceData, setAlert)
            )

            if (createdService) {
                const newService = {
                    id: createdService.id,
                    label: createdService.title,
                    value:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                    slug:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                }
                setOtherServicesArr([...otherServicesArr, newService])
                setValue('newOtherService', '')
                setShowOtherServiceInput(false)
            }
        }
    }

    const licensedServiceState = watch('licensedService')
    const otherServiceState = watch('otherService')

    useEffect(() => {
        if (licensedServiceState) {
            const alreadyExist = servicesArr.find(
                (i) => i.slug === licensedServiceState.slug
            )
            if (alreadyExist) {
                setAlert('This service already exist', 'error')
                setValue('licensedService', '')
                return
            }
            setServicesArr([...servicesArr, licensedServiceState])
            setValue('licensedService', '')
        }
    }, [licensedServiceState])

    useEffect(() => {
        if (otherServiceState) {
            const alreadyExist = otherServicesArr.find(
                (i) => i.slug === otherServiceState.slug
            )
            if (alreadyExist) {
                setAlert('This service already exist', 'error')
                setValue('otherService', '')
                return
            }
            setOtherServicesArr([...otherServicesArr, otherServiceState])
            setValue('otherService', '')
        }
    }, [otherServiceState])

    useEffect(() => {
        dispatch(GetLicensedServicesAction())
        dispatch(GetOtherServicesAction())
    }, [])

    useEffect(() => {
        setConstructionType(profileDetailsdata.construction_type || '')
    }, [profileDetailsdata.construction_type])

    const onSubmit = (obj) => {
        const objToSend = {
            servicesArr,
            otherServicesArr,
            constructionType,
        }
        console.log(objToSend)
        dispatch(UpdateProfileAction(objToSend, 'services', setAlert))
    }

    const removeService = (ind, whichService) => {
        if (whichService === 'licensedService') {
            servicesArr.splice(ind, 1)
            setServicesArr([...servicesArr])
        } else {
            otherServicesArr.splice(ind, 1)
            setOtherServicesArr([...otherServicesArr])
        }
    }
    return (
        <>
            <section className={styles.profile_services}>
                <div className={styles.profile_information_heading}>
                    <Typography noWrap variant="h5" fontWeight={'bold'}>
                        Services Provided
                    </Typography>
                    {/* <IconCmp>
                        <BiEdit />
                    </IconCmp> */}
                </div>

                <Grid container spacing={1}>
                    <Grid sm={4}>
                        <section className={styles.servicesLicensed}>
                            <Typography
                                noWrap
                                mt={'40px'}
                                variant="h6"
                                fontWeight={'600'}
                            >
                                Construction Type
                            </Typography>
                            <Box sx={{ my: '20px', maxWidth: 300 }}>
                                <DropDownCmp
                                    name="constructionType"
                                    control={{
                                        ...control,
                                        register: (...args) => {
                                            const original = control.register(
                                                ...args
                                            )
                                            return {
                                                ...original,
                                                onChange: (e) => {
                                                    setConstructionType(
                                                        e.target.value
                                                    )
                                                    if (original.onChange)
                                                        original.onChange(e)
                                                },
                                            }
                                        },
                                    }}
                                    label="Construction Type"
                                    options={[
                                        'Residential',
                                        'Commercial',
                                        // 'Both (Residential + Commercial)',
                                        'Both',
                                    ]}
                                    placeholder="Select Construction Type"
                                    disableClearable
                                    freeSolo={false}
                                    value={constructionType}
                                />
                            </Box>
                        </section>
                    </Grid>
                    <Grid sm={8}>
                        <section className={styles.servicesLicensed}>
                            <Typography
                                noWrap
                                mt={'40px'}
                                variant="h6"
                                fontWeight={'600'}
                            >
                                Licensed Service
                            </Typography>
                            <Box sx={{ my: '20px' }}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <DropDownCmp
                                            name="licensedService" //imporant
                                            control={control} //imporant
                                            label="Select Services"
                                            options={
                                                licensedServicesdata && [
                                                    ...licensedServicesdata,
                                                    // ...otherServicesdata,
                                                ]
                                            }
                                            disableClearable
                                            freeSolo={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* ///tags// */}
                            <div>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: '20px',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    {servicesArr.length > 0 &&
                                        servicesArr.map((service, ind) => {
                                            return (
                                                <div
                                                    key={ind}
                                                    className={
                                                        styles.scrollTabsBar
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            gap: '5px',
                                                        }}
                                                    >
                                                        <img
                                                            alt="serviceLogo"
                                                            src={AccountAlert}
                                                            style={{
                                                                marginBottom:
                                                                    '2px',
                                                            }}
                                                        />
                                                        {service.label}
                                                    </Box>
                                                    <Box>
                                                        <CloseIcon
                                                            sx={{
                                                                cursor: 'pointer',
                                                                fontSize:
                                                                    '18px',
                                                                mt: '5px',
                                                            }}
                                                            onClick={() =>
                                                                removeService(
                                                                    ind,
                                                                    'licensedService'
                                                                )
                                                            }
                                                        />
                                                    </Box>
                                                </div>
                                            )
                                        })}
                                </Box>
                            </div>
                        </section>
                    </Grid>
                    <Grid sm={8}>
                        <section className={styles.servicesLicensed}>
                            <Typography noWrap variant="h6" fontWeight={'600'}>
                                Other Service
                            </Typography>
                            <Box sx={{ my: '20px', maxWidth: 300 }}>
                                <DropDownCmp
                                    name="otherService"
                                    control={control}
                                    label="Select Other Services"
                                    options={
                                        otherServicesdata
                                            ? otherServicesdata
                                            : []
                                    }
                                    disableClearable
                                    freeSolo={false}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '20px',
                                    flexWrap: 'wrap',
                                }}
                            >
                                {otherServicesArr.length > 0 &&
                                    otherServicesArr.map((service, ind) => (
                                        <div
                                            key={ind}
                                            className={styles.scrollTabsBar}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px',
                                                }}
                                            >
                                                {service.label}
                                            </Box>
                                            <Box>
                                                <CloseIcon
                                                    sx={{
                                                        cursor: 'pointer',
                                                        fontSize: '18px',
                                                        mt: '5px',
                                                    }}
                                                    onClick={() =>
                                                        removeService(
                                                            ind,
                                                            'otherServicesArr'
                                                        )
                                                    }
                                                />
                                            </Box>
                                        </div>
                                    ))}
                            </Box>
                        </section>
                    </Grid>
                    <Grid sm={8}>
                        <section className={styles.servicesLicensed}>
                            {showOtherServiceInput ? (
                                <Grid item xs={8}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <InputCmp
                                            name="newOtherService"
                                            control={control}
                                            label="Enter new service name"
                                            style={{ flex: 1, minWidth: 300 }}
                                        />
                                        <ButtonCmp
                                            title={
                                                createServiceLoading
                                                    ? 'Adding...'
                                                    : 'Add'
                                            }
                                            onClick={handleAddNewOtherService}
                                            type="button"
                                            disabled={createServiceLoading}
                                        />
                                        <WhiteButtonCmp
                                            title="Cancel"
                                            onClick={handleCancelOtherService}
                                            type="button"
                                            disabled={createServiceLoading}
                                        />
                                    </Box>
                                </Grid>
                            ) : (
                                <Grid item lg={2}>
                                    <ButtonCmp
                                        title="Add New Service"
                                        onClick={() =>
                                            setShowOtherServiceInput(true)
                                        }
                                        type="button"
                                    />
                                </Grid>
                            )}
                        </section>
                    </Grid>
                </Grid>
                {/* ////other services// */}
                {/* <section className={styles.servicesLicensed}>
                    <Typography noWrap variant="h6" fontWeight={'600'}>
                        Other Service
                    </Typography>
                    <Box sx={{ my: '20px' }}>
                        <Grid container>
                            <Grid item xs={6}>
                                <DropDownCmp
                                    name="otherService" //imporant
                                    control={control} //imporant
                                    label="Select Services"
                                    options={
                                        otherServicesdata && otherServicesdata
                                    }
                                    disableClearable
                                    freeSolo={false}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <div>
                        <Box sx={{ display: 'flex', gap: '20px' }}>
                            {otherServicesArr.length > 0 &&
                                otherServicesArr.map((service, ind) => {
                                    return (
                                        <div
                                            key={ind}
                                            className={styles.scrollTabsBar}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '5px',
                                                }}
                                            >
                                                <img
                                                    alt="serviceLogo"
                                                    src={AccountAlert}
                                                    style={{
                                                        marginBottom: '2px',
                                                    }}
                                                />
                                                {service.label}
                                            </Box>
                                            <Box>
                                                <CloseIcon
                                                    sx={{
                                                        cursor: 'pointer',
                                                        fontSize: '18px',
                                                        mt: '5px',
                                                    }}
                                                    onClick={() =>
                                                        removeService(
                                                            ind,
                                                            'otherService'
                                                        )
                                                    }
                                                />
                                            </Box>
                                        </div>
                                    )
                                })}
                        </Box>
                    </div>
                </section> */}
            </section>
            <div
                className={styles.buttonContainer}
                style={{
                    paddingRight: '40px',
                }}
            >
                {/* <section> */}

                <WhiteButtonCmp
                    title="Cancel"
                    onClick={() => handleCancel('servicesInfo')}
                />
                {/* </section>
                    <section> */}
                <ButtonCmp
                    title="Save"
                    style={{ marginLeft: '10px' }}
                    onClick={handleSubmit(onSubmit)}
                />
                {/* </section> */}
            </div>
        </>
    )
}

export default ServicesForm
